// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ContractorInfo
 */
export interface ContractorInfo {
    /**
     * 
     * @type {string}
     * @memberof ContractorInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorInfo
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorInfo
     */
    contractorType: ContractorInfoContractorTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContractorInfoContractorTypeEnum {
    Juridical = 'juridical',
    Physical = 'physical'
}



